import React from "react";

import { Box, styled, Slider, Typography, Stack } from "@mui/material";
import { fontWeight } from "config/Theme/options";
import { useMUIThemeModeContext } from "context/MUIThemeModeContext";
import { useTranslation } from "react-i18next";
import { IBitcoinerChallenge } from "types/types";
import { renderNumber } from "utils/formatter";

export const CustomSlider = styled(Slider)(({ theme }) => {
  const { colors } = useMUIThemeModeContext();

  return {
    color: theme.palette.primary.main,
    pointerEvents: "none",
    height: 7,
    paddingTop: 1,

    "& .MuiSlider-track": {
      boxShadow: "2px 0px 4px 0px rgba(0, 0, 0, 0.1)",
    },
    "& .MuiSlider-rail": {
      backgroundColor: colors.powderBlue,
      opacity: 1,
    },
    "& .MuiSlider-mark": {
      display: "none",
    },
    "& .MuiSlider-thumb": {
      height: 5,
      width: 5,
      marginLeft: -3,
      backgroundColor: colors.white,
      "&:before": {
        boxShadow: "none",
      },
    },
    "& .MuiSlider-valueLabel": {
      fontWeight: 800,
      fontSize: "1rem",
      fontFamily: "Nunito",
      top: 40,
      backgroundColor: "unset",
      color: theme.palette.primary.main,
    },
  };
});

interface IProps {
  overview: IBitcoinerChallenge
}

const XPProgress: React.FC<IProps> = ({ overview }) => {
  const { t } = useTranslation();
  const { colors } = useMUIThemeModeContext();

  const getProgressPercentage = (currentXP: number, maxXP: number) => {
    if (maxXP === 0) return 0;
    return Math.round((100 * currentXP) / maxXP);
  };

  return (
    <Box boxShadow="0px 9px 10px 0px rgba(0,0,0,0.05)" px={{ xs: 2, md: 4 }} pt={1.5} pb={3} borderRadius={2} width={"100%"}>
      <Stack direction={"row"} justifyContent={"space-between"}>
        <Typography fontWeight={fontWeight.extraBold} fontFamily={"Nunito"} fontSize={"0.875rem"}>
          {t("bitcoinerChallenge.level", { level: overview.levelNumber })}
        </Typography>
        <Typography
          fontWeight={fontWeight.extraBold}
          fontFamily={"Nunito"}
          fontSize={"0.875rem"}
          textAlign={"right"}
          color={colors.gray500}>
          {t("bitcoinerChallenge.nextLevel", {
            nextLevel: overview.levelNumber + 1,
            nextLevelXp: renderNumber(overview.xpForNextLevel),
          })}
        </Typography>
      </Stack>
      <CustomSlider
        min={0}
        max={100}
        value={getProgressPercentage(overview.xpTotal, overview.xpForNextLevel)}
        valueLabelDisplay={"on"}
        valueLabelFormat={`${renderNumber(overview.xpTotal)} XP`}
      />
    </Box>
  );
};

export default XPProgress;
